import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import {
  emailError,
  genericError,
  inviteSuccess,
  invitationDeleteSuccess,
} from '@/utils/alerts.service';
import router from '@/router/dashboard.js';

/*
  This is the form to send invitations to agencies
*/
export const invite = {
  namespaced: true,
  state: {
    invitation: {},
  },
  getters: {
    invitation(state) {
      return state.invitation;
    },
  },
  mutations: {
    setInvitation(state, data) {
      state.invitation = data;
    },
  },
  actions: {
    async sendInvite({ dispatch }, invite) {
      const data = {
        techPartnerContactName: invite.name,
        techPartnerContactEmail: invite.email,
        techPartnerCompanyName: invite.agencyName,
      };

      return vendorDashboardAPI
        .sendIntegrationInvite(data)
        .then(() => {
          dispatch('showUserMessage', { ...inviteSuccess }, { root: true });
          router.push('/integration-partners');
        })
        .catch(() => {
          dispatch('showUserMessage', { ...emailError }, { root: true });
        });
    },

    async resendIntegrationInvite({ dispatch }, email) {
      const data = {
        email: email,
      };

      return vendorDashboardAPI
        .resendIntegrationInvite(data)
        .then(() => {
          dispatch('showUserMessage', { ...inviteSuccess }, { root: true });
          router.push('/integration-partners');
        })
        .catch(() => {
          dispatch('showUserMessage', { ...emailError }, { root: true });
        });
    },

    async fetchInvitationDetail({ commit, dispatch }, id) {
      return vendorDashboardAPI
        .getIntegrationInvitationDetail(id)
        .then(data => {
          commit('setInvitation', data);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async deleteIntegrationInvitation({ dispatch }, id) {
      return vendorDashboardAPI
        .deleteIntegrationInvitation(id)
        .then(() => {
          dispatch(
            'showUserMessage',
            { ...invitationDeleteSuccess },
            { root: true }
          );
          router.push('/integration-partners');
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },
  },
};
